var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BrandingSliderComponent"},[_c('VueSlickCarousel',_vm._b({},'VueSlickCarousel',_vm.settings,false),_vm._l((_vm.images),function(image,key){return _c('div',{key:key,staticClass:"px-5"},[_c('v-img',{attrs:{"src":image,"max-height":"150px","contain":""}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }